module.exports = __webpack_public_path__ + "img/sousuo.97b51e91.png";